import {isProductOrderable} from '../../../utils/product-utils'

const UNIVERSAL_SWATCH_IMAGE = `data:image/svg+xml;utf8,${encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><circle cx="13" cy="13" r="13" fill="white"/></svg>'
)}`

/**
 * True when the product carries a color variation with at least one value.
 *
 * @param {Object} product
 * @returns {boolean}
 */
export const hasColorVariation = (product) =>
    Boolean(product?.variationAttributes?.some(({id, values}) => id === 'color' && values?.length))

/**
 * Return a swatch-ready product for the universal color fallback.
 *
 * When a product has no color variation, this creates a synthetic single-option color
 * variation so it can still render through ColorSwatches.Root. Products that already
 * carry a color variation are returned as they are.
 *
 * @param {Object} product
 * @param {Function} formatMessage
 * @returns {Object}
 */
export const getUniversalSwatchProduct = (product, formatMessage) => {
    if (hasColorVariation(product)) {
        return product
    }

    const universalLabel = formatMessage({
        id: 'product_detail.color.universal',
        defaultMessage: 'Universal'
    })
    const colorLabel = formatMessage({
        id: 'product_detail.color',
        defaultMessage: 'Colour'
    })
    const orderable = isProductOrderable(product)
    const variationValues = {...product?.variationValues, color: 'universal'}

    return {
        ...product,
        variationValues,
        variationAttributes: [
            ...(product?.variationAttributes?.filter(({id}) => id !== 'color') || []),
            {
                id: 'color',
                name: colorLabel,
                values: [{name: universalLabel, value: 'universal', orderable}]
            }
        ],
        variants: [
            ...(product?.variants || []),
            {
                productId: product.id,
                variationValues,
                orderable
            }
        ],
        imageGroups: [
            ...(product?.imageGroups || []),
            {
                viewType: 'swatch',
                variationAttributes: [{id: 'color', values: [{value: 'universal'}]}],
                images: [
                    {
                        alt: universalLabel,
                        title: universalLabel,
                        disBaseLink: UNIVERSAL_SWATCH_IMAGE,
                        link: UNIVERSAL_SWATCH_IMAGE
                    }
                ]
            }
        ]
    }
}
